import * as React from 'react';
import * as ReactDOM from 'react-dom';
import * as _ from 'lodash';
import { createStore, applyMiddleware } from 'redux';
import { Provider } from 'react-redux';
import thunk from 'redux-thunk';
import { SearchPageApp } from './components/search-page-app';
import { rootReducer, IState } from './reducers/index';
import { fetchResults } from './actions/results';
import { IBrowserAction, browser, updateResults, IAction, ISetPageAction, ISetSearchTermAction, setPage, noResults, getResults, ActionType, setSearchTerm, updateSearchCategory } from './actions/index';
import { BrowserRouter } from 'react-router-dom';
import { RouterToUrlQuery, addUrlProps, UrlQueryParamTypes, subquery, configureUrlQuery, urlQueryMiddleware } from 'react-url-query';
import { ICategoryResult } from './state-helpers/categories';
import 'babel-polyfill';

function presetSearch(isMct: boolean) {
    var query = decodeURIComponent(window.location.search.replace(/\+/g, '%20'));
    var vars = query.split('&');

    //Handle default cases for fields that are not set
    if (query) {
        if (_.includes(query, "categories") == false) {
            var emptyCategories: ICategoryResult[] = [];
            store.dispatch(updateSearchCategory(emptyCategories as ICategoryResult[]));
        }
    }

    var categoryList = [];
    //Read existing query strings' values into their respective components
    for (var i = 0; i < vars.length; i++) {

        var pair = vars[i];

        if (_.includes(pair, "k=")) {
            var encodedQuery = pair.split('=')[1];
            var decodedQuery = decodeURIComponent(encodedQuery);
            store.dispatch(setSearchTerm(decodedQuery));
        }

        if (_.includes(pair, "page")) {
            var item = pair.split('=')[1];
            store.dispatch(setPage(parseInt(item)));
        }

        if (_.includes(pair, "categories")) {
            var categories = pair.split('=')[1];
            categoryList = JSON.parse(decodeURIComponent(categories)) as ICategoryResult[];
        }

        store.dispatch(updateSearchCategory(categoryList));
    }
    //If search criteria exists, fetch results
    if (query) {
        store.dispatch(fetchResults(false, isMct));
    }
}

//Create store with middleware using the default reducer
var createStoreWithMiddleware = applyMiddleware(thunk, urlQueryMiddleware())(createStore);
var store = createStoreWithMiddleware(rootReducer);

//Render the search application by attaching it to the placeholder element search-page-app
const searchPageMount = document.getElementById('search-page-app');
const isMct = searchPageMount.getAttribute('data-mct') === 'true';

//Run the preset search function on page load and on browser actions
presetSearch(isMct);


store.dispatch(fetchResults(false, isMct));

// link the history used in our app to url-query so it can update the URL with it.
// do not auto generate change handlers since we won't be using them, we'll use
// those we create in mapDispatchToProps
configureUrlQuery({ history, addChangeHandlers: false });



//Render Search Application

// Wrap application(s) in the react-redux Provider component (allows these "smart" components
// to subscribe to state updates and dispatch events).
//var searchPageApp = React.createElement(Provider, { store }, searchRouter);

//Wrap application(s) in the RouterToUrlQuery component to allow manipulation of query string variables
//using redux's actions and dispatches

//Wrap the RouterToUrlQuery component in the BrowserRouter component to allow the manipulation of the 
//browser history

ReactDOM.render(
    <Provider store={store}>
        <BrowserRouter>
            <RouterToUrlQuery>
                <SearchPageApp  />
            </RouterToUrlQuery>
        </BrowserRouter>
    </Provider>, searchPageMount);


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./App/search-page/index.tsx